// firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBkFXhL5Q7h0xuCJeUEZhBOZ8M05HOnE5o",
  authDomain: "albert-3d.firebaseapp.com",
  projectId: "albert-3d",
  storageBucket: "albert-3d.firebasestorage.app",
  messagingSenderId: "940698982283",
  appId: "1:940698982283:web:1a7e3103ffd6dfd579418e",
  measurementId: "G-VKSE3Z272J"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics, logEvent };
